<div *ngIf="!sparcDataLoaded;else main_content">
  <app-loading-spinner></app-loading-spinner>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="mt-5 detail-name" style="font-size:x-large;">
        This report may take a minute to generate.
      </div>
    </div>
  </div>
</div>

<ng-template #main_content>
  <div class="speaking-score-outer-container container mb-4">
    <div class="row">
      <div class="speaking-score-inner-container sparc-title-container text-center col-3">
        <div class="speaking-score-sparc-line h4">SPARC</div>
        <div class="speaking-score-long-line h6">Speaking Proficiency&nbsp;Score</div>
      </div>
      <div class="speaking-score-inner-container speaking-score-number-container col-2">
        <h6 class="speaking-score-text">AVERAGE</h6>
        <div class="speaking-score-number-box">
          <div *ngIf="showSPARCData" class="h1 speaking-score-number">{{ currentOrgAverageSparc }}</div>
          <h1 *ngIf="!showSPARCData" class="speaking-score-text" style="padding-bottom: 0">--</h1>
          <div *ngIf="orgAvgIncreased" class="speaking-score-icon"
            ngbTooltip="Average has gone up since last month." placement="end"
            tooltipClass="custom-tooltip-styling"><i class="fas fa-caret-up h1" style="color: #79C045;"></i></div>
          <div *ngIf="orgAvgDecreased" class="speaking-score-icon"
            ngbTooltip="Average has gone down since last month." placement="end"
            tooltipClass="custom-tooltip-styling"><i class="fas fa-caret-down h1" style="color: #FD362C;"></i></div>
        </div>
      </div>
      <div class="speaking-score-inner-container speaking-score-progress-chart-container col-7">
        <h6 class="speaking-score-text">AVERAGE OVER TIME</h6>
        <div class="speaking-score-progress-chart-box">
          <canvas *ngIf="showSPARCData" #speakingScoreChart>{{ chart }}</canvas>
          <h6 *ngIf="!showSPARCData" class="speaking-score-text" style="padding-bottom: 0; width: 65%">
            No data available yet.<br>Keep using Joy School English to get enough speaking opportunities to generate
            data.
          </h6>
        </div>
      </div>
    </div>
  </div>
  <app-organization-classes-data [organizationId]="organizationId"></app-organization-classes-data>
</ng-template>